export default __webpack_public_path__ + "static/media/me2.f1609fce.jpg";